export const VOTING_MODULE_ANSWER_TEST_ID = "voting-module-answer";
export const VOTING_MODULE_ANSWER_COUNT_TEST_ID = "voting-module-answer-count";
